import * as t from "io-ts";

export const BreakpointV = t.type({
  id: t.string,
  label: t.string,
  minWidth: t.union([t.number, t.undefined, t.null]),
  maxWidth: t.union([t.number, t.undefined, t.null]),
  defaultPreviewWidth: t.union([t.number, t.literal("100%")])
});

export type Breakpoint = t.TypeOf<typeof BreakpointV>;
